module.exports = __webpack_public_path__ + "img/indu_active_10.8c5216cd.png";